// src/app/modules/capitalShare/redux/reducer.ts
import {CapitalShareState} from '../Model'
import {
  CS_CBS_LOOKUP_REQUEST, CS_CBS_LOOKUP_SUCCESS, CS_CBS_LOOKUP_FAILURE, CS_CBS_LOOKUP_RESET,
  CS_FETCH_LIST_REQUEST, CS_FETCH_LIST_SUCCESS, CS_FETCH_LIST_FAILURE,
  CS_SUBMIT_REQUEST, CS_SUBMIT_SUCCESS, CS_SUBMIT_FAILURE,
  CS_FETCH_CASE_REQUEST, CS_FETCH_CASE_SUCCESS, CS_FETCH_CASE_FAILURE,
  CS_CHECKER_ACTION_REQUEST, CS_CHECKER_ACTION_SUCCESS, CS_CHECKER_ACTION_FAILURE,
  CS_FETCH_FEE_CONFIG_SUCCESS, CS_UPDATE_FEE_CONFIG_SUCCESS,
} from './constants'

const initialState: CapitalShareState = {
  cbsLoading: false,
  cbsCustomer: null,
  cbsError: null,
  feeConfig: {demat_enabled: true, mero_share_enabled: true, rules: []},
  feeConfigLoading: false,
  applications: [],
  listLoading: false,
  listTotal: 0,
  currentCase: null,
  caseLoading: false,
  actionLoading: false,
  actionError: null,
}

export const reducer = (state = initialState, action: any): CapitalShareState => {
  switch (action.type) {
    case CS_CBS_LOOKUP_REQUEST:
      return {...state, cbsLoading: true, cbsCustomer: null, cbsError: null}
    case CS_CBS_LOOKUP_SUCCESS:
      return {...state, cbsLoading: false, cbsCustomer: action.payload}
    case CS_CBS_LOOKUP_FAILURE:
      return {...state, cbsLoading: false, cbsError: action.payload}
    case CS_CBS_LOOKUP_RESET:
      return {...state, cbsCustomer: null, cbsError: null}

    case CS_FETCH_LIST_REQUEST:
      return {...state, listLoading: true}
    case CS_FETCH_LIST_SUCCESS:
      return {...state, listLoading: false, applications: action.payload.data, listTotal: action.payload.total}
    case CS_FETCH_LIST_FAILURE:
      return {...state, listLoading: false}

    case CS_SUBMIT_REQUEST:
      return {...state, actionLoading: true, actionError: null}
    case CS_SUBMIT_SUCCESS:
      return {...state, actionLoading: false}
    case CS_SUBMIT_FAILURE:
      return {...state, actionLoading: false, actionError: action.payload}

    case CS_FETCH_CASE_REQUEST:
      return {...state, caseLoading: true, currentCase: null}
    case CS_FETCH_CASE_SUCCESS:
      return {...state, caseLoading: false, currentCase: action.payload}
    case CS_FETCH_CASE_FAILURE:
      return {...state, caseLoading: false}

    case CS_CHECKER_ACTION_REQUEST:
      return {...state, actionLoading: true, actionError: null}
    case CS_CHECKER_ACTION_SUCCESS:
      return {...state, actionLoading: false}
    case CS_CHECKER_ACTION_FAILURE:
      return {...state, actionLoading: false, actionError: action.payload}

    case CS_FETCH_FEE_CONFIG_SUCCESS:
      return {...state, feeConfig: action.payload, feeConfigLoading: false}
    case CS_UPDATE_FEE_CONFIG_SUCCESS:
      return {...state, feeConfig: action.payload}

    default:
      return state
  }
}
